import { render, staticRenderFns } from "./BusTurnAssignCrud.vue?vue&type=template&id=4c6df1c6"
import script from "./BusTurnAssignCrud.vue?vue&type=script&lang=js"
export * from "./BusTurnAssignCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports